import { z } from 'zod';
import { OpaqueRef } from './ids.js';
import { IsoDateTime, PositiveCents } from './primitives.js';
import { Slot } from './slot.js';
/**
 * A short-lived claim on a slot, so two guests are not sold the same 2 PM while
 * one of them is still deciding. Expiry is enforced by every query filtering on
 * `expires_at > now()`; the sweeper is a convenience, not the mechanism.
 */
export const Hold = z.object({
    hold_id: OpaqueRef,
    expires_at: IsoDateTime,
});
/**
 * Statuses that occupy the room. Only these count as `busy` in the availability
 * engine, which is what makes a cancellation return the slot to the book.
 */
export const LIVE_BOOKING_STATUSES = ['confirmed', 'completed'];
export const BookingStatus = z.enum(['confirmed', 'completed', 'cancelled', 'no_show']);
export const Booking = z.object({
    booking_id: OpaqueRef,
    status: BookingStatus,
    slot: Slot,
    service_id: OpaqueRef,
    party_size: z.number().int().min(1),
    value_cents: PositiveCents,
    guest_ref: OpaqueRef,
    created_at: IsoDateTime,
});
export const CancelResult = z.object({
    booking_id: OpaqueRef,
    status: z.literal('cancelled'),
    fee_cents: PositiveCents,
    cancelled_at: IsoDateTime,
});
/** Where a booking came from. Every write records it; the reports depend on it. */
export const BookingSource = z.enum(['staff', 'partner', 'import', 'walk_in']);
//# sourceMappingURL=booking.js.map